import { ReactComponent as ReportIcon } from "components/icons/DangerTriangle.svg";
import { ReactComponent as HideIcon } from "components/icons/eye.svg";
// import addIcon from "components/icons/FolderAdd2.svg";
import { ReactComponent as ShareIcon } from "components/icons/share-red.svg";
import { ReactComponent as CollectionIcon } from "components/icons/bookmark.svg";
import { ReactComponent as ManageIcon } from "components/icons/manage_icon.svg";
import { ReactComponent as GearIcon } from "components/icons/gear.svg";

export const getMoreMenuData = ({ actions, currentUser, gif }: any) => {
  const {
    onHide,
    onManageClick,
    toggleCollection,
    toggleReport,
    toggleShareMenu,
    toggleChangeNichesDialog,
    toggleGifPrefs
  } = actions;

  const isAuth = !!currentUser;
  const isCM = !!currentUser?.isContentManager();
  const isThisUserGif = gif.userName === currentUser?.username;

  return [
    {
      groupName: null,
      groupMobileName: null,
      items: [
        {
          icon: ShareIcon,
          title: "Share",
          onClick: toggleShareMenu
        },
        // ...(isAuth ? [{
        //   icon: addIcon,
        //   title: "Add to a niche",
        //   onClick: toggleNiche
        // }] : []),
        ...(isAuth ? [{
          icon: CollectionIcon,
          title: "Add to a collection",
          onClick: toggleCollection
        }] : []),
        {
          icon: ReportIcon,
          title: "Report",
          onClick: toggleReport
        },
        ...(isCM ? [{
          icon: HideIcon,
          title: "Hide",
          onClick: onHide
        }] : []),
        ...(isCM ? [{
          icon: GearIcon,
          title: "Change niches",
          onClick: toggleChangeNichesDialog,
        }] : []),
        ...(isCM ? [{
          icon: GearIcon,
          title: "Type",
          onClick: toggleGifPrefs,
        }] : []),
        ...(isThisUserGif ? [{
          icon: ManageIcon,
          title: "Manage",
          onClick: onManageClick,
        }] : []),
      ]
    }
  ];
};
